import { Attachment } from '@mui/icons-material';
import CardWrapper from '../wrapper/card';
import { formatDateWithTime } from '../../helper';
import LabelWrapper from '../wrapper/label';
import { settingSelectedTab } from '../../redux/slices/task';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

const RecentFilesComponent = () => {
    const { id } = useParams();
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { files, loaders } = useSelector((state: RootState) => state.file);
    const navigateFilesHandler = () => {
        dispatch(settingSelectedTab(1));
        navigate(`/app/client/${id}/task-files`);
    };

    if (loaders.isLoading) {
        return <CardWrapper minHeight="200px">
            <Box display="flex" alignItems="center" flexDirection="column" height="200px" justifyContent="center">
                <CircularProgress />
                <Typography variant="body2">Loading...</Typography>
            </Box>
        </CardWrapper>;
    }

    return <CardWrapper minHeight="200px">
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography color="textSecondary" variant="h6">Docs & Files</Typography>
            <Button variant="text" onClick={navigateFilesHandler}>View All</Button>
        </Box>
        {files && files.length > 0
            ? <>
                {
                    files.map((file, index) => (
                        <Box key={index} display="flex" justifyContent="space-between" alignItems="start">
                            <Box>
                                <Typography variant="subtitle1" fontSize="16px" fontWeight="bold">{file.file_name}</Typography>
                                <Typography variant="body2" fontSize="12px">{file.formatted_size}</Typography>
                            </Box>
                            <Typography variant="body2" fontSize="11px" color="textSecondary">{formatDateWithTime(file.created_at)}</Typography>
                        </Box>
                    ))
                }
            </>
            : <>
                <LabelWrapper label="No files added" />
                <Attachment color="info" fontSize="large" />
            </>}
    </CardWrapper>;
};

export default RecentFilesComponent;